<script setup>
/* eslint-disable no-unused-vars */
/* global defineProps, defineEmits */
// Components
//import SharedDialog from "../../../components/shared/SharedDialog.vue";
import { getAllPages } from "@/utils/getAllPages";
import SharedDeleteConfirmDialog from "@/components/shared/SharedDeleteConfirmDialog.vue";
import SharedInput from "../../../components/shared/SharedInput.vue";
import SharedDropdown from "../../../components/shared/SharedDropdown.vue";
import SharedModal from "../../../components/shared/SharedModal.vue";
import HeaderTitle from "@/components/layout/HeaderTitle.vue";
import { useAutomaticSearch } from "@/app/composables/useAutomaticSearch";

// Services
// Services
import ResourceService from '@/api/services/resource.service';
import Notification from '@/utils/plugins/NotificationService';

import { computed, getCurrentInstance, onMounted, ref } from "vue";
import { useUiStore } from "@/app/stores/uiStore";


const props = defineProps({});

const uiStore = useUiStore();

const instance = getCurrentInstance();

const workplace = ref({});

const workplaces = ref([]);

const submitted = ref(false);

const deleteDialogShown = ref(false);

const selectedWorkplace = ref(null);

const workplaceName = ref('');

const workplaceAddress = ref('');

const postalCode = ref('');

const location = ref({});

const locations = ref([]);
let locationsRequestId = 0;

const province = ref({});

const provinces = ref([]);

const showModalWorkplaceAddress = ref(false);


const createOrUpdateWorkplace = ref(false);

const searchFilterWorkplaceName = ref('');
const { beginRequest, isCurrentRequest } = useAutomaticSearch(searchFilterWorkplaceName, () => getWorkplaces());

const selectProvinceFocus = ref(false);

const errorWorkplace = ref({
  name: false,
  province: false,
  location: false
});

async function getWorkplaces(searchQuery = searchFilterWorkplaceName.value) {
  uiStore.startLoading();
  const requestId = beginRequest();
  try {
    const result = await getAllPages(ResourceService.getWorkplaces, { name: searchQuery });
    if (isCurrentRequest(requestId)) workplaces.value = result;
  } finally {
    uiStore.stopLoading();
  }
}

function deleteWorkplace(workplace) {
  ResourceService.deleteWorkplace(workplace.id).then(() => {
    Notification.addNotification('Centro de trabajo eliminado correctamente.', 'success', 6000);
    selectedWorkplace.value = null;
    deleteDialogShown.value = false;
    getWorkplaces();
  }).catch(() => {
    Notification.addNotification('Error al eliminar el centro de trabajo seleccionado', 'error', 6000);
    // this.$uiStore.setLoading(false);
    uiStore.stopLoading();
  });
}

function createWorkplace() {
  if (checkErrors()) return;
  const workplaceData = {
    name: workplaceName.value,
    province: workplace.value.province['@id'],
    location: workplace.value.location['@id'],
    address: workplaceAddress.value,
    postalCode: parseInt(postalCode.value),
  };
  // this.$uiStore.setLoading(true);
  uiStore.startLoading();
  ResourceService.createWorkplace(workplaceData).then(() => {
    Notification.addNotification({
      type: 'success',
      message: 'Centro de trabajo creado correctamente',
      duration: 6000
    });
    // this.$uiStore.setLoading(false);
    uiStore.stopLoading();
    cancel();
  }).catch(() => {
    Notification.addNotification('Error al crear el centro de trabajo', 'error', 6000);
    // this.$uiStore.setLoading(false);
    uiStore.stopLoading();
  }).finally(() => {
    closeCreateOrUpdateDialog();
  });
}

function editWorkplace(workplaceData) {
  selectedWorkplace.value = workplaceData;
  workplaceName.value = workplaceData.name;
  province.value = { ...workplaceData.province };
  location.value = { ...workplaceData.location };
  workplace.value = { province: province.value, location: location.value };
  createOrUpdateWorkplace.value = true;
  if (province.value.id != null) getLocationsById(province.value.id, true);
  workplaceAddress.value = workplaceData.address;
  postalCode.value = workplaceData.postalCode;
}

function handleUpdateWorkplace() {
  if (checkErrors()) return;
  selectedWorkplace.value.name = workplaceName.value;
  selectedWorkplace.value.province = workplace.value.province['@id'];
  selectedWorkplace.value.location = workplace.value.location['@id'];
  selectedWorkplace.value.address = workplaceAddress.value;
  selectedWorkplace.value.postalCode = parseInt(postalCode.value);
  updateWorkplace(selectedWorkplace.value);
}

async function updateWorkplace(workplace) {
  // this.$uiStore.setLoading(true);
  uiStore.startLoading();
  await ResourceService.updateWorkplace(workplace, workplace.id).then(() => {
    Notification.addNotification({
      type: 'success',
      message: 'Centro de trabajo actualizado',
      duration: 6000
    });
    // this.$uiStore.setLoading(false);
    uiStore.stopLoading();
    cancel();
  }).catch(() => {
    Notification.addNotification('Error al actualizar el centro de trabajo', 'error', 6000);
    // this.$uiStore.setLoading(false);
    uiStore.stopLoading();
  }).finally(() => {
    closeCreateOrUpdateDialog();
  });
}

function reset() {
  locationsRequestId++;
  workplace.value = {};
  workplaceName.value = '';
  selectedWorkplace.value = null;
  location.value = {};
  locations.value = [];
  province.value = {};
  workplaceAddress.value = '';
  postalCode.value = '';
  errorWorkplace.value.name = false;
  errorWorkplace.value.province = false;
  errorWorkplace.value.location = false;
}

function cancel() {
  reset();
  getWorkplaces();
}

function closeCreateOrUpdateDialog() {
  createOrUpdateWorkplace.value = false;
  reset();
}

function openModalEmployeeAddress() {
  if (instance.proxy.employee) {
    if (instance.proxy.employee.province) {
      instance.proxy.getLocationsByProvince(instance.proxy.employee.province);
    }
  }
  showModalWorkplaceAddress.value = true;
}

function closeModalWorkplaceAddress(str) {
  switch (str) {
    case 'cancelar':
      province.value = {};
      location.value = {};
      break;
    case 'aceptar':
      break;
    default:
      break;
  }
  showModalWorkplaceAddress.value = !showModalWorkplaceAddress.value;
}

function getProvinces(searchQuery = null) {
  const params = searchQuery ? {
    name: searchQuery
  } : {};
  uiStore.startLoading();
  ResourceService.getProvinces(params)
    .then(res => {
      provinces.value = res.data['hydra:member'];
    })
    .finally(() => {
      uiStore.stopLoading();
    });
}

function getLocationsById(id, preserveLocation = false) {
  let params = {
    page: 1,
    itemsPerPage: 99999
  };
  const requestId = ++locationsRequestId;
  workplace.value.province = provinces.value.find(x => x.id === id) || (province.value.id === id ? province.value : {});
  if (!preserveLocation) {
    location.value = {};
    workplace.value.location = {};
  }
  locations.value = [];
  uiStore.startLoading();
  ResourceService.getLocationsByProvinceId(params, id).then(res => {
    if (requestId !== locationsRequestId) return;
    locations.value = res.data['hydra:member'];
    if (workplace.value.location?.id != null) {
      changeLocation(workplace.value.location.id);
    }
  }).catch(() => {
    if (requestId === locationsRequestId) {
      Notification.addNotification('Error al cargar las localidades', 'error', 6000);
    }
  }).finally(() => {
    uiStore.stopLoading();
  });
}

function changeLocation(id) {
  let newLocation = locations.value.find(x => x.id === id);
  if (newLocation) {
    workplace.value.location = newLocation;
  } else {
    location.value = {};
    workplace.value.location = {};
  }
}

function checkErrors() {
  errorWorkplace.value.name = workplaceName.value === '' || workplaceName.value === null || workplace.value === undefined;
  errorWorkplace.value.province = province.value.id == null || province.value.id == undefined;
  errorWorkplace.value.location = location.value.id == null || location.value.id == undefined;
  return errorWorkplace.value.name || errorWorkplace.value.province || errorWorkplace.value.location;
}

function filterNumbers() {
  postalCode.value = postalCode.value.replace(/\D/g, "");
}

function createNewWorkplace() {
  createOrUpdateWorkplace.value = true;
  reset();
}

onMounted(() => {
  getWorkplaces();
  getProvinces();
});
</script>

<template>
  <div>
    <HeaderTitle title="Ajustes" />
    <div class="d-flex flex-row justify-content-start">
      <img src="@/assets/icons/group.svg" width="30" alt="">
      <div class="title-text pl-4">
        Centros de Trabajo
      </div>
    </div>
    <el-card class="card-search w-100 wback" body-style="padding:0">
      <div class="row mx-5 master-search-row">
        <div class="col-12">
          <div class="row align-items-end">
            <div class="col-md-4 col-12">
              <div class="form-item date-picker label-common">
                <label class="w-100 mb-2">Nombre</label>
                <el-input v-model="searchFilterWorkplaceName" placeholder="Nombre del Centro de Trabajo" prefix-icon="el-icon-search" clearable />
              </div>
            </div>
            <div class="col-md-4 offset-md-4 col-12 d-flex justify-content-end master-search-actions">
              <button @click="createNewWorkplace" class="btn btn_darkpink btn-search master-create-button">
                NUEVO CENTRO DE TRABAJO
              </button>
            </div>
          </div>
        </div>
      </div>
    </el-card>
    <div class="table table-not-mobile">
      <div v-if="workplaces && workplaces.length > 0">
        <table>
          <thead>
            <tr>
              <th>Nombre Centro de Trabajo</th>
              <th class="master-actions-col">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="workplace in workplaces" :key="workplace.id" class="pointer" @click="editWorkplace(workplace)">
              <td>
                {{ workplace.name }}
              </td>
              <td class="master-actions-col">
                <div class="buttons d-inline-flex">
                  <font-awesome-layers class="fa-2x pointer" style="margin-left: 5px" title="Editar"
                    @click.stop="editWorkplace(workplace)">
                    <font-awesome-icon icon="circle" style="color: #f7d20e" />
                    <font-awesome-icon icon="plus" class="fa-inverse" transform="shrink-6" />
                  </font-awesome-layers>
                  <font-awesome-layers class="fa-2x pointer" style="margin-left: 5px" title="Eliminar"
                    @click.stop="deleteDialogShown = true; selectedWorkplace = workplace;">
                    <font-awesome-icon icon="circle" style="color:red" />
                    <font-awesome-icon icon="times" class="fa-inverse" transform="shrink-6" />
                  </font-awesome-layers>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <h5>No se han encontrado centros de trabajo</h5>
      </div>
    </div>

    <div class="table-mobile">
      <div v-if="workplaces && workplaces.length > 0">
        <el-row v-for="workplace in workplaces" :key="workplace.id" class="mt-3">
          <el-card class="master-mobile-card w-100 pointer" @click="editWorkplace(workplace)">
            <div class="master-mobile-card__delete">
              <font-awesome-layers class="fa-2x pointer" title="Eliminar" @click.stop="deleteDialogShown = true; selectedWorkplace = workplace;">
                <font-awesome-icon icon="circle" style="color:red" />
                <font-awesome-icon icon="times" class="fa-inverse" transform="shrink-6" />
              </font-awesome-layers>
            </div>
            <div class="master-mobile-card__title">{{ workplace.name }}</div>
          </el-card>
        </el-row>
      </div>
      <div v-else class="mt-3">
        <h5>No se han encontrado centros de trabajo</h5>
      </div>
    </div>

    <el-dialog v-model="createOrUpdateWorkplace" class="dense-dialog workplace-dialog" @closed="closeCreateOrUpdateDialog()"
      :show-close="false" size="'medium'" width="850" :center="true" :lock-scroll="true"
      :style="{ borderRadius: `var(--el-border-radius-round)` }">
      <div class="my-header">
        <svg id="asterisk" xmlns="http://www.w3.org/2000/svg" width="724" height="1024" viewBox="0 0 724 1024">
          <path
            d="M0 499.8l59-181.7 332.5 108.6-59 180.8-332.5-107.7zM79.6 744.3l206.1-282.9 154.5 111.5-206.1 283.8-154.5-112.4zM266.9 167.3h191.1v350.3h-191.1v-350.3zM285.6 572.9l154.5-111.5 206.1 282.9-154.5 112.4-206.1-283.8zM332.5 426.8l332.5-108.6 59 181.7-331.6 107.7-59.9-180.8z" />
        </svg>
        <span class="text-header ml-5 mt-3">{{ selectedWorkplace ? 'Actualizar' : 'Nuevo' }} Centro de trabajo</span>
        <img class="close-icon pointer" src="@/assets/images/aspa_blue_small_entrada.png" alt=""
          @click="closeCreateOrUpdateDialog()">
      </div>
      <div class="my-body">
        <form @submit.prevent="">
          <div class="form-group row">
            <div class="col-12">
              <div class="form-item">
                <label for="workplaceName" class="w-100">Nombre del Centro de Trabajo:</label>
                <el-input v-model="workplaceName" :placeholder="'Nombre del Centro de Trabajo'" class="mt-1" />
                <p v-if="errorWorkplace.name" class="invalid-feedback mb-0">
                  <small>
                    Este campo es obligatorio
                  </small>
                </p>
              </div>
            </div>
            <div class="col-12">
              <div class="form-item row">
                <div class="col-md-6 col-12">
                  <label for="workplaceProvinces" class="w-100">Provincia</label>
                  <el-select v-model="province.id" class="w-100" filterable placeholder="Provincia"
                    @focus="selectProvinceFocus = true" @blur="selectProvinceFocus = false"
                    @change="getLocationsById(province.id)">
                    <el-option v-for="province in provinces" :key="province.id" :label="province.name"
                      :value="province.id">
                    </el-option>
                  </el-select>
                  <p v-if="errorWorkplace.province" class="invalid-feedback mb-0">
                    <small>
                      Este campo es obligatorio
                    </small>
                  </p>
                </div>
                <div class="col-md-6 col-12">
                  <label for="workplaceLocations" class="w-100">Localidad</label>
                  <el-select v-model="location.id" class="w-100" placeholder="Localidad" filterable :disabled='selectProvinceFocus'
                    @change="changeLocation(location.id)">
                    <el-option v-for="location in locations" :key="location.id" :label="location.name"
                      :value="location.id">
                    </el-option>
                  </el-select>
                  <p v-if="errorWorkplace.location" class="invalid-feedback mb-0">
                    <small>
                      Este campo es obligatorio
                    </small>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-item">
                <label for="workplaceAddress" class="w-100">Direccion:</label>
                <el-input v-model="workplaceAddress" :placeholder="'Dirección del centro de trabajo'" class="mt-1" />
              </div>
            </div>
            <div class="col-12">
              <div class="form-item">
                <label for="workplacePostalCode" class="w-100">Codigo Postal:</label>
                <el-input v-model="postalCode" :placeholder="'Codigo Postal'" class="mt-1" @input="filterNumbers"
                  maxlength="5" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 offset-md-8 col-12 d-flex flex-column justify-content-end align-items-end master-dialog-actions">
                <button class="btn btn_darkpink"
                  @click="selectedWorkplace ? handleUpdateWorkplace() : createWorkplace()">
                  {{ selectedWorkplace ? 'Actualizar' : 'Nuevo' }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </el-dialog>

    <SharedDeleteConfirmDialog v-model="deleteDialogShown" title="Eliminar centro de trabajo"
      message="¿Desea eliminar permanentemente este centro de trabajo?" @confirm="deleteWorkplace(selectedWorkplace)"
      @cancel="selectedWorkplace = null" />


    <!--    Direccion Postal del Centro de Trabajo-->
    <shared-modal v-if="showModalWorkplaceAddress" :title="'Dirección postal'" :theme="'secundary'" size="'medium'"
      @close="closeModalWorkplaceAddress()">
      <template #content>
        <div class="modal_address">
          <form class="address-form" @submit.prevent="saveEmployee(employee)">
            <!--            Calle-->
            <label style="color: black">Dirección</label>
            <SharedInput v-model="employee.address" :param="'employeeAdress'" :color="'address'"
              :rules="{ required: true }" :placeholder="'Dirección de la calle'" :validate="submitted" />


            <!--                <div class="col-md-4" v-if="!employee.province || employee.province && employee.province.id === 1">-->
            <div class="form-item">
              <div class="row">
                <div class="col-md-6">
                  <label for="employeeProvinces" style="color: black">Provincia</label>
                  <SharedDropdown id="employeeProvinces" v-model="employee.province" :items="provinces"
                    :selected="employee.province ? employee.province : province" :searchable="true"
                    data-vv-as="provincia" :rules="{ required: submitted }" data-vv-name="employeeProvinces"
                    :label="'employeeProvinces'" :removable="false" :param="'name'"
                    :is-invalid="submitted && errors.has('employeeProvinces')" :color="'address'" :title="'Provincia'"
                    @search="getProvinces($event)"
                    @selectItem="province = $event; employee.province = province; employee.postalCode = province.id; getLocationsByProvince(province);" />
                  <div v-if="submitted && errors.has('employeeProvinces')" class="animated fadeIn invalid-feedback">
                    <font-awesome-icon class="icon" icon="info-circle" />
                    {{ errors.first('employeeProvinces') }}
                  </div>
                </div>
                <div class="col-md-6">
                  <label for="employeeLocations" style="color: black">Localidad</label>
                  <!--                    @search="getLocations($event)"-->
                  <SharedDropdown id="employeeLocations" v-model="employee.location" :items="locations"
                    :selected="employee.location ? employee.location : location" :searchable="true"
                    data-vv-as="localidad" :rules="{ required: submitted }" data-vv-name="employeeLocations"
                    :label="'employeeLocations'" :removable="false" :param="'name'"
                    :is-invalid="submitted && errors.has('employeeLocations')" :color="'address'" :title="'Localidad'"
                    @search="getLocations($event)" @selectItem="location = $event; employee.location = location;" />
                  <div v-if="submitted && errors.has('employeeLocations')" class="animated fadeIn invalid-feedback">
                    <font-awesome-icon class="icon" icon="info-circle" />
                    {{ errors.first('employeeLocations') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="form-item">
              <label style="color: black">Código postal</label>
              <SharedInput v-model="employee.postalCode" :type="'number'" :param="'employeePostalCode'"
                :color="'address'" :rules="{ required: true }" :placeholder="'Código postal'" :validate="submitted" />
            </div>
          </form>
          <br>
          <div class="row item">
            <div class="col">
              <button class="btn btn-block btn_red" @click="closeModalWorkplaceAddress('cancelar')">
                Cancelar
              </button>
            </div>
            <div class="col">
              <button class="btn btn_blue" @click="closeModalWorkplaceAddress('aceptar')">
                Aceptar
              </button>
            </div>
          </div>
        </div>
      </template>
    </shared-modal>
  </div>
</template>

<style lang="scss" scoped>
.my-body.my-body { margin-right: 0; }
.master-search-row .form-item { margin-bottom: 0; }
.master-create-button { width: 100%; max-width: 300px; min-height: 44px; margin-bottom: 0 !important; color: white; }
@media (max-width: 767px) { .master-search-row .form-item { margin-bottom: 12px; } }
.workplace-input {
  /*display: flex;*/
  vertical-align: baseline;
  margin: 30px 10px 10px 10px;
}

.card-search {
  height: 200px;
}

.table-mobile {
  display: none;
}

.master-mobile-card {
  border-radius: 16px;
}

.master-mobile-card :deep(.el-card__body) {
  position: relative;
  padding: 16px 18px;
}

.master-mobile-card__delete {
  position: absolute;
  top: 10px;
  right: 12px;
  z-index: 1;
}

.master-mobile-card__title {
  color: $bg-blue;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.25;
  padding-right: 42px;
  word-break: break-word;
}

.master-actions-col {
  width: 110px;
  min-width: 110px;
  text-align: center;
}

/*
.table-workplace {
  table {
    //margin-left: auto;
    //margin-right: auto;
    //width: auto;
  }
}
*/

.el-dialog__body {
  background: #f3f0fb !important;
  min-height: 800px !important;

  .el-dialog__header {
    padding: 0;
  }

  .my-header {
    margin-top: 2px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .text-header {
      text-align: left;
      font-size: 4em;
      font-weight: 900;
      letter-spacing: -0.05em;
      color: #f9156f;
    }

    .close-icon {
      width: 8%;
      height: 20%;
    }

    .inter-icon {
      width: 2%;
      height: 2%;
    }

    #asterisk {
      position: absolute;
      vertical-align: super;
      height: auto;
      width: 2.2em;
      fill: #f9156f;
    }

  }

}

@media (max-width: 767px) {
  .title-text {
    font-size: 2.2em;
  }

  .card-search {
    height: auto;
    padding: 20px 16px;
    background-size: 92px;
    background-position: calc(100% + 16px) 12px;
  }

  .master-search-row {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .master-search-actions {
    width: 100%;
    flex-direction: column;
    align-items: stretch !important;
    gap: 10px;
    margin-top: 10px;
  }

  .master-search-actions .btn-search {
    width: 100%;
    max-width: 100% !important;
    min-width: 100% !important;
  }

  .table-not-mobile {
    display: none;
  }

  .table-mobile {
    display: block;
    padding-right: 14px;
  }

  :deep(.workplace-dialog) {
    width: calc(100vw - 24px) !important;
    max-width: calc(100vw - 24px);
    margin-top: 4vh !important;
  }

  :deep(.workplace-dialog .el-dialog__body) {
    min-height: auto !important;
  }

  .el-dialog__body .my-header {
    align-items: flex-start;
    gap: 12px;
    padding-right: 10px;
  }

  .el-dialog__body .my-header .text-header {
    font-size: 2em;
    line-height: 1.1;
    margin-top: 0.75rem !important;
  }

  .el-dialog__body .my-header .close-icon {
    width: 26px;
    min-width: 26px;
    margin-top: 12px;
  }

  .el-dialog__body .my-body {
    margin-right: 0;
  }

  .form-item.row {
    row-gap: 14px;
  }

  .master-dialog-actions {
    align-items: stretch !important;
    margin-left: 0 !important;
  }

  .master-dialog-actions .btn {
    width: 100%;
  }
}
</style>
